module.exports = __webpack_public_path__ + "static/02-c64d016ebee66d4a7269dce280255e0c.jpg";